import { appendLocaleSources } from '../../hooks/useTranslate'
import SettingPresenter from '../../api/settingPresenter'

appendLocaleSources({
  [SettingPresenter.urn]: {
    page: {
      title: 'Настройки',
    },
    modal: {
      title: {
        create: 'Создать настройку',
        update: 'Обновить настройку',
      }
    },
    action: {
      create: 'Добавить настройку',
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить эту настройку?`,
    }
  }
}, 'ru')
